import { render, staticRenderFns } from "./WechatMerchantManage.vue?vue&type=template&id=75874a42&"
import script from "./WechatMerchantManage.vue?vue&type=script&lang=js&"
export * from "./WechatMerchantManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports